export const monthData = [
    { label: 'Jan', key: 1 },
    { label: 'Feb', key: 2 },
    { label: 'Mar', key: 3 },
    { label: 'Apr', key: 4 },
    { label: 'May', key: 5 },
    { label: 'Jun', key: 6 },
    { label: 'Jul', key: 7 },
    { label: 'Aug', key: 8 },
    { label: 'Sep', key: 9 },
    { label: 'Oct', key: 10 },
    { label: 'Nov', key: 11 },
    { label: 'Dec', key: 12 },
];

export const startDayMapping = {
    Sunday: 0,
    Monday: 1,
    Tuesday: 2,
    Wednesday: 3,
    Thursday: 4,
    Friday: 5,
    Saturday: 6,
};

//get total number of days in a month
export function daysInMonth(month: number, year: number) {
    return new Date(year, month, 0).getDate();
}

//get all the starting days in a month
export function getStartingDayInMonth(year: number, month: number, startingDay: number = 1) {
    const d = new Date(year, month - 1);
    const mon = d.getMonth();
    const days = [];
    d.setDate(1);
    // Get the first starting day in the month
    while (d.getDay() !== startingDay) {
        d.setDate(d.getDate() + 1);
    }

    // Get all the other starting days in the month
    while (d.getMonth() === mon) {
        days.push({
            month,
            day: d.getDate(),
            date: new Date(d.getTime()),
        });
        d.setDate(d.getDate() + 7);
    }

    return days;
}

export type dayType = 'Monday' | 'Tuesday' | 'Wednesday' | 'Thursday' | 'Friday' | 'Saturday' | 'Sunday';

//get all starting days in a year and store it in an object
export function getAllDaysInYear(year: number, startDayOfWeek: dayType = 'Monday') {
    const startDayIndex = startDayMapping[startDayOfWeek];
    const result: any = {};
    for (let i = 1; i <= 12; i++) {
        const startDaysInMonth = getStartingDayInMonth(year, i, startDayIndex);
        result[i] = startDaysInMonth;
    }
    return result;
}
